import { api } from "@/lib/api";
import { toast } from "sonner";

export const DOCS = [
  { key: "durc", label: "DURC in corso di validità", expiry: true },
  { key: "tracciabilita", label: "Tracciabilità dei Flussi Finanziari (L. 136/2010)" },
  { key: "autodichiarazione", label: "Autodichiarazione requisiti (artt. 94-95 D.Lgs. 36/2023)" },
  { key: "polizza_rct", label: "Polizza RCT", expiry: true },
];
export const MEPA_DOC = { key: "mepa", label: "Prova di abilitazione MePA / Consip" };

export const DECLARATION = "Dichiaro, ai sensi degli artt. 46 e 47 del D.P.R. 445/2000, che i documenti caricati sono autentici, veritieri e in corso di validità, assumendomene la piena ed esclusiva responsabilità e sollevando il portale Artisti in Comune da ogni responsabilità in merito al loro contenuto.";

export const eur = (n) => `€ ${Number(n || 0).toLocaleString("it-IT", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
export const itDate = (d) => (d ? new Date(d).toLocaleDateString("it-IT") : "-");

export async function downloadFile(path, fallbackName) {
  try {
    const r = await api.get(path, { responseType: "blob" });
    const cd = r.headers["content-disposition"] || "";
    const name = (cd.match(/filename="([^"]+)"/) || [])[1] || fallbackName;
    const url = URL.createObjectURL(r.data);
    const a = document.createElement("a");
    a.href = url; a.download = name; document.body.appendChild(a); a.click(); a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 2000);
  } catch {
    toast.error("Download non riuscito");
  }
}
